<template>
  <div class="wage-total-manage-main">
    <el-row justify="space-between" style="align-items:center;">
      <div>
        <span>来源：</span>
        <el-cascader v-model="sourceId" :options="projects" :props="projectProps" ref="projectCascader" clearable @change="projectChange" />
      </div>
      <div>
        <span>时间：</span>
        <el-button-group style="margin: auto 15px;">
          <el-button :type="monthReangeType === 1 ? 'primary' : 'default'" @click="toMonthRange(1)">本月</el-button>
          <el-button :type="monthReangeType === 2 ? 'primary' : 'default'" @click="toMonthRange(2)">上月</el-button>
          <el-button :type="monthReangeType === 3 ? 'primary' : 'default'" @click="toMonthRange(3)">近三年</el-button>
          <el-button :type="monthReangeType === 4 ? 'primary' : 'default'" @click="toMonthRange(4)">今年</el-button>
        </el-button-group>
        <el-date-picker v-model="salaryMonthRange" type="monthrange" align="right" unlink-panels range-separator="至"
          start-placeholder="开始月份" end-placeholder="结束月份" value-format="YYYY-MM"
          @change="salaryMonthRangeChange" style="margin-right: 15px;width: 250px;">
        </el-date-picker>
      </div>
    </el-row>

    <el-row justify="space-between">
      <statistics-map :idProvinceData="statistics.idProvince" />
      <statistics-table :totalData="statistics.total || {}" :idProvinceData="statistics.idProvince" />
    </el-row>

    <el-row justify="space-between">
      <sex-total :statisticsData="statistics.total" />
      <month-salary-range :statisticsData="statistics.monthSalaryRange" />
      <age-range :statisticsData="statistics.ageRange" />
    </el-row>

    <el-row justify="space-between">
      <avg-month-trend  :statisticsData="statistics.salaryMonth" />
      <work-name  :statisticsData="statistics.workName" />
      <sum-month-trend  :statisticsData="statistics.salaryMonth" />
    </el-row>

  </div>
</template>
<script>
import { getSlipTotalStatistics } from "@/api/wage/total";
import { defineComponent } from "vue";


import StatisticsMap from './StatisticsMap.vue';
import StatisticsTable from './StatisticsTable.vue';
import SexTotal from './SexTotal.vue';
import MonthSalaryRange from './MonthSalaryRange.vue';
import AgeRange from './AgeRange.vue';
import AvgMonthTrend from './AvgMonthTrend.vue';
import WorkName from './WorkName.vue';
import SumMonthTrend from './SumMonthTrend.vue';
import { formatDate } from "@/utils/datetime";
import { getProjectTreeList } from "@/api/proman/prouser";

export default defineComponent({
  components: { StatisticsMap, StatisticsTable, SexTotal, MonthSalaryRange, AgeRange, AvgMonthTrend, WorkName, SumMonthTrend },
  data() {
    return {
      projects: [],
      sourceId: null,
      salaryMonthRange: [],
      statistics: {},
      monthReangeType: 0,
      params: {
        salaryMonthStart: null,
        salaryMonthEnd: null
      },
      projectProps: {
        checkStrictly: true,
        emitPath: false,
        value: 'id',
        label: 'name'
      }
    };
  },
  mounted() {
    this.getProjectTree();
    this.getData();
  },
  methods: {
    getProjectTree() {      
      getProjectTreeList({currentPage: 1, pageSize: 100000, questType: 'WAGETOTAL'}).then(({data}) => {
        this.projects = data.data;        
      });
    },
    getData() {
      getSlipTotalStatistics(this.params).then(({ data }) => {
        this.statistics = data.data;
      });
    },
    salaryMonthRangeChange(val) {
      if (val) {
        this.params.salaryMonthStart = val[0];
        this.params.salaryMonthEnd = val[1];
      } else {
        this.params.salaryMonthStart = null;
        this.params.salaryMonthEnd = null;
      }
      this.monthReangeType = 0;
      this.getData();
    },
    toMonthRange(type) { // type: 1:本月，2：上月，3：近三年，4：今年
      let date = new Date();
      let salaryMonthStart, salaryMonthEnd;
      if (type === 1) {
        salaryMonthStart = formatDate(date, 'yyyy-MM');
        salaryMonthEnd = salaryMonthStart;
      } else if (type === 2) {
        date.setMonth(date.getMonth() - 1);
        salaryMonthStart = formatDate(date, 'yyyy-MM');
        salaryMonthEnd = salaryMonthStart;
      } else if (type === 3) {
        salaryMonthEnd = formatDate(date, 'yyyy-MM');
        date.setFullYear(date.getFullYear() - 3);
        date.setMonth(date.getMonth() + 1);
        salaryMonthStart =  formatDate(date, 'yyyy-MM');
      } else if (type === 4) {
        salaryMonthEnd = formatDate(date, 'yyyy-MM');
        date.setMonth(0);
        salaryMonthStart =  formatDate(date, 'yyyy-MM');
      }

      this.monthReangeType = type;
      this.params.salaryMonthStart = salaryMonthStart;
      this.params.salaryMonthEnd = salaryMonthEnd;
      this.salaryMonthRange = [salaryMonthStart, salaryMonthEnd];
      this.getData();
    },
    projectChange(val) {
      let node = (this.$refs.projectCascader.getCheckedNodes()[0] || {}).data || {};
      if (node.groupName) {
        this.params.projectId = null;
        this.params.teamId = null;
        this.params.groupId = node.id;
      } else if (node.teamName) {
        this.params.projectId = null;
        this.params.teamId = node.id;
        this.params.groupId = null
      } else if (node.projectName) {
        this.params.projectId = node.id;
        this.params.teamId = null;
        this.params.groupId = null
      } else {
        this.params.projectId = null;
        this.params.teamId = null;
        this.params.groupId = null
      }
      this.getData();
    }
  },
});
</script>

<style lang="scss" scoped>
.wage-total-manage-main {
  padding: 15px;
  .el-row {
    margin-bottom: 15px;
  }
}
</style>